import React, { useEffect, useRef, useState } from 'react'
import MetricCard from './MetricCard'
import { dashboardColors, theme } from '../../../../themes/Theme';
import FilterDropdown from '../EventsSummary/FilterDropdown';
import CustomDateRangeModal from '../EventsSummary/CustomDateRangeModal';
import { getDateRangeISO } from '../AccountLevelReportConstant';
import moment from 'moment';
import { getOrganiserReports } from '../../../../revampCRUD/accountLevelReports.crud';
import customToast from '../../../../components/common/basic/Toast';

const ReportsOverview = ({ OverviewDateFilterOptions = "lastWeek", selectedCurrency = null }) => {

  const [overviewDateFilter, setOverviewDateFilter] = useState("lastWeek");
  const [overviewData, setOverviewData] = useState({
    registrations: 0,
    sales: 0,
    expenses: 0,
    income: 0,
    chartsData: []
  });
  const [loading, setLoading] = useState(false);
  const [openDateModal, setOpenDateModal] = useState(false);
  const [customDateRange, setCustomDateRange] = useState({
    startDate: null,
    endDate: null,
    isActive: false
  });

  const modalRef = useRef(null);

  const fetchOverviewData = async (dateRange = overviewDateFilter) => {
    try {
      setLoading(true);

      const customRange = dateRange === 'custom' && customDateRange.isActive
        ? customDateRange
        : null;

      const { from_timestamp, to_timestamp } = getDateRangeISO(dateRange, customRange);

      if (!from_timestamp || !to_timestamp) {
        return;
      }

      const response = await getOrganiserReports({
        metric: "overview",
        from_timestamp,
        to_timestamp,
        event_currency: selectedCurrency?.currency_id,
      });

      const apiData = response?.data || {};
      const metricsCount = apiData?.reports?.metrics_count || {};
      const metricsPerDay = apiData?.reports?.metrics_per_day || [];

      const newOverviewData = {
        registrations: parseInt(metricsCount?.registrations_count) || 0, 
        sales: parseFloat(metricsCount?.sale) || 0,                    
        expenses: parseFloat(metricsCount?.expense) || 0,               
        income: parseFloat(metricsCount?.income) || 0,                  
        chartsData: metricsPerDay
      };

      setOverviewData(newOverviewData);

    } catch (err) {
      customToast.error(err?.response?.data?.error || 'Something went wrong');

    } finally {
      setLoading(false);
    }
  };

  const fetchOverviewWithCustomDates = async (customRange) => {
    try {
      setLoading(true);

      const from_timestamp = moment(customRange?.startDate)?.startOf('day')?.toISOString();
      const to_timestamp = moment(customRange?.endDate)?.endOf('day')?.toISOString();

      const response = await getOrganiserReports({
        metric: 'overview',
        from_timestamp,
        to_timestamp,
        event_currency: selectedCurrency?.currency_id
      });

      const apiData = response?.data || {};
      const metricsCount = apiData?.reports?.metrics_count || {};
      const metricsPerDay = apiData?.reports?.metrics_per_day || [];

      const newOverviewData = {
        registrations: parseInt(metricsCount?.registrations_count) || 0,
        sales: parseFloat(metricsCount?.sale) || 0,
        expenses: parseFloat(metricsCount?.expense) || 0,
        income: parseFloat(metricsCount?.income) || 0,
        chartsData: metricsPerDay
      };

      setOverviewData(newOverviewData);

    } catch (err) {
      customToast.error(err?.response?.data?.error || 'Something went wrong');

    } finally {
      setLoading(false);
    }
  };

  const handleCustomDateProceed = (selectedDates) => {
    const newCustomRange = {
      startDate: selectedDates?.startDate,
      endDate: selectedDates?.endDate,
      isActive: true
    };

    setCustomDateRange(newCustomRange);
    setOverviewDateFilter('custom');

    // Fetch data with custom dates
    fetchOverviewWithCustomDates(newCustomRange);
  };

  const handleDateFilterChange = (option) => {

    if (option.value === 'custom') {
      if (option.startDate && option.endDate) {
        const newCustomRange = {
          startDate: option.startDate,
          endDate: option.endDate,
          isActive: true
        };

        setCustomDateRange(newCustomRange);
        setOverviewDateFilter('custom');
        fetchOverviewWithCustomDates(newCustomRange);
      } else {
        setOpenDateModal(true);
      }
    } else {
      setCustomDateRange({ startDate: null, endDate: null, isActive: false });
      setOverviewDateFilter(option.value);
      // fetchOverviewData(option.value);
    }
  };

  useEffect(() => {
    if (selectedCurrency?.currency_id) {
      fetchOverviewData();
    }
  }, [selectedCurrency,overviewDateFilter]);
  useEffect(() => {
    if (selectedCurrency?.currency_id && overviewDateFilter !== 'custom') {
      // fetchOverviewData(overviewDateFilter);
    }
  }, [overviewDateFilter]);

  useEffect(() => {
    if (selectedCurrency?.currency_id && customDateRange.isActive && overviewDateFilter === 'custom') {
      fetchOverviewWithCustomDates(customDateRange);
    }
  }, [customDateRange.isActive]);


  return (
    <div className='report-overview-cont d-flex flex-column richtext-gap-3 '>
      <div className='d-flex align-items-center justify-content-between'><span className='report-overview-label'>Overview</span>
        <FilterDropdown
          options={OverviewDateFilterOptions || []}
          value={overviewDateFilter}
          onChange={handleDateFilterChange}
          onCustomSelect={() => setOpenDateModal(true)}
          className="event-status-filter"
          placeholder="Active Events"
        /></div>

      <CustomDateRangeModal
      ref={modalRef}
        isOpen={openDateModal}
        onClose={() => {
          setOpenDateModal(false);
        }}
        onProceed={handleCustomDateProceed}
        timeZone="UTC"
        initialStartDate={ customDateRange?.startDate || null}
        initialEndDate={ customDateRange?.endDate || null}
      />
      <MetricCard
        metricsData={overviewData}
        selectedCurrency={selectedCurrency}
        loading={loading}
      />
      <style jsx>{
        `
      
      .report-overview-cont{
          padding :  20px;
          box-shadow: 0px 0px 20px 9px #002E6E24;
          border-radius:4px;
          background-color:#fff;
          height:100%;
        }
         .report-overview-label{
            font-size: 18px;
            font-weight: 600;
            color: ${dashboardColors[theme].primaryTextColor};
        }
      `
      }</style>
    </div>
  )
}

export default ReportsOverview